import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { DBIntFieldObjective, DBDropDown, DBTextArea, ToolTipBulb } from '_components';
import styles from './NonMaterialHandling.module.css';
import { noteActions } from '_actions';

class PatientCareCenterNoteObjectiveNonMaterialHandling extends React.Component {

    render() {
        let options = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' }
        ];
        let todayMeasurementsOptions = [
            { id: 'Occasional', value: 'Occasional' },
            { id: 'Frequent', value: 'Frequent' },
            { id: 'Constant', value: 'Constant' },
            { id: 'N/A', value: 'N/A' },
            { id: 'N/T', value: 'N/T' },
            { id: 'Unable', value: 'Unable' }
        ];
        return (
            <PatientCareCenterNoteSection id='nonMaterialHandling' name='Non Material Handling' refProp={this.props.refProp} level={5}>
                <div className={styles.row}>
                    <label className={styles.col1}><strong>Client can:</strong></label>
                    <label className={styles.col2}><strong>Job Requirement</strong></label>
                    <label className={styles.col3}><strong>Today's Measurements</strong></label>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Walk</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMWALKJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMWALKCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevWalkCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Sit</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSITJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSITCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevSitCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Stand</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSTANDJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSTANDCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevStandCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Balance 25 ft.</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMBALANCEJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMBALANCECUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevBalanceCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Kneel</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMKNEELJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMKNEELCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevKneelCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Crawl 25 ft.</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMCRAWLJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMCRAWLCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevCrawlCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Reach Overhead</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMOVERHEADJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMOVERHEADCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevOverheadCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Reach Forward</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMFORWARDJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMFORWARDCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevForwardCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Bend</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMBENDJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMBENDCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevBendCur}
                        </span>
                    </div>
                </div>


                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Squat</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSQUATJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSQUATCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevSquatCur}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Twist</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMTWISTJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMTWISTCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevTwistCur}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Ladder Climb</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMLADDERJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMLADDERCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevLadderCur}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Stair Climb</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSTAIRJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMSTAIRCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevStairCur}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label>Manual Dexterity</label>
                    </div>

                    <div className={styles.col2_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMDEXTERITYJOB'
                            customOptions={options}
                        />
                    </div>

                    <div className={styles.col3_row}>

                        <DBDropDown
                            className={styles.drop_down}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVENONMATHAND'
                            entityKeyColumn='NMNO'
                            entityKeyValue={this.props.nmno}
                            field='NMDEXTERITYCUR'
                            customOptions={todayMeasurementsOptions}
                        />
                        <span className={styles.prev_wrapper}>
                            {this.props.prevDexterityCur}
                        </span>
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.col1_row}>
                        <label><strong>Comments</strong></label>
                    </div>
                </div>


                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVENONMATHAND'
                    entityKeyColumn='NMNO'
                    entityKeyValue={this.props.nmno}
                    field='NMCOMMENTS'
                    className={styles.textarea}
                />
                <span className={styles.prev_comments_wrapper}>
                    {this.props.prevComments}
                </span>
            </PatientCareCenterNoteSection>
        );
    }
}


function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let nmno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVENONMATHAND)
        .find(key => (state.entities.notes.PTOBJECTIVENONMATHAND[key].NMEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVENONMATHAND[key].NMNTNO === pk && noteType !== 1)));

    // Get previous values
    let prevWalkCur = '';
    let prevSitCur = '';
    let prevStandCur = '';
    let prevBalanceCur = '';
    let prevKneelCur = '';
    let prevCrawlCur = '';
    let prevOverheadCur = '';
    let prevForwardCur = '';
    let prevBendCur = '';
    let prevSquatCur = '';
    let prevTwistCur = '';
    let prevLadderCur = '';
    let prevStairCur = '';
    let prevDexterityCur = '';
    let prevComments = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]) {
        prevWalkCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMWALKCUR'];
        prevSitCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMSITCUR'];
        prevStandCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMSTANDCUR'];
        prevBalanceCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMBALANCECUR'];
        prevKneelCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMKNEELCUR'];
        prevCrawlCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMCRAWLCUR'];
        prevOverheadCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMOVERHEADCUR'];
        prevForwardCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMFORWARDCUR'];
        prevBendCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMBENDCUR'];
        prevSquatCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMSQUATCUR'];
        prevTwistCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMTWISTCUR'];
        prevLadderCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMLADDERCUR'];
        prevStairCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMSTAIRCUR'];
        prevDexterityCur = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMDEXTERITYCUR'];
        prevComments = state.entities.notes.PTOBJECTIVENONMATHANDPREV[pk]['NMCOMMENTS'];
    }

    return {
        noteId,
        nmno,
        // Previous values
        prevWalkCur,
        prevSitCur,
        prevStandCur,
        prevBalanceCur,
        prevKneelCur,
        prevCrawlCur,
        prevOverheadCur,
        prevForwardCur,
        prevBendCur,
        prevSquatCur,
        prevTwistCur,
        prevLadderCur,
        prevStairCur,
        prevDexterityCur,
        prevComments,
    };
}

const connectedPatientCareCenterNoteObjectiveNonMaterialHandling = connect(mapStateToProps)(PatientCareCenterNoteObjectiveNonMaterialHandling);
export { connectedPatientCareCenterNoteObjectiveNonMaterialHandling as PatientCareCenterNoteObjectiveNonMaterialHandling };

